<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Site Setup</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
        </div>
      </div>

      <div class="input-row-3">
      <!-- col 1 -->
      <div>
        <div class="inputCard">
          <header>Site Info</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Site Meta Name</label>
              <input v-model="state.siteData.site_name" placeholder="Level Seven Studio" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Site Meta Title</label>
              <input v-model="state.siteData.site_title" placeholder="Website and App Design" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Site Meta Keywords</label>
              <input v-model="state.siteData.site_keywords" placeholder="keyword1, keyword2, etc." class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Site Meta Description</label>
              <input v-model="state.siteData.site_description" placeholder="Websites and Apps in Ormond Beach, FL" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Site Logo</label>
              <div class="w3-right-align">
                <label for="file" class="w3-button w3-green w3-small">Upload Image</label>
                <input id="file" type="file" @change="uploadLogo($event.target.files)" ref="slide1FileUpload" accept=".png,.jpg" class="inputFile" />
              </div>
            </div>
            <div class="w3-border-bottom w3-padding-8">
              <img v-if="state.siteData.site_logo.url !== ''" :src="state.siteData.site_logo.url" style="height:34px" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Google Analytics</label>
              <input v-model="state.siteData.site_google_analytics_key" placeholder="UA-XXXXXX-X" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Cookie Popup</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.site_cookie_popup">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>COVID-19 Banner</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.site_covid19">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>COVID-19 Open</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.site_covid19open">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- col 2 -->
      <div>
        <!-- Contact Info -->
        <div class="inputCard">
          <header>Contact Information</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Address Line 1</label>
              <input v-model="state.siteData.contact.address.street1" placeholder="123 Street Ave" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Address Line 2</label>
              <input v-model="state.siteData.contact.address.street2" placeholder="Unit 123" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>City</label>
              <input v-model="state.siteData.contact.address.city" placeholder="Daytona Beach" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>State</label>
              <input v-model="state.siteData.contact.address.state" placeholder="FL" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Zip Code</label>
              <input v-model="state.siteData.contact.address.zip" placeholder="32117" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Phone</label>
              <input v-model="state.siteData.contact.phone" placeholder="(386) 456-7890" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Phone Link</label>
              <input v-model="state.siteData.contact.phoneLink" placeholder="tel:3864567890" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Second Phone</label>
              <input v-model="state.siteData.contact.phone2" placeholder="(386) 456-7890" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Second Phone Link</label>
              <input v-model="state.siteData.contact.phone2Link" placeholder="tel:3864567890" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Fax</label>
              <input v-model="state.siteData.contact.fax" placeholder="386-123-4567" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Email</label>
              <input v-model="state.siteData.contact.email" placeholder="email@mydomain.com" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Email Subject</label>
              <input v-model="state.siteData.contact.email_subject" placeholder="Website Contact" class="w3-input w3-border" />
            </div>
          </div>
        </div>
      </div>
      <!-- col 3 -->
      <div>
        <!-- Business Info -->
        <div class="inputCard">
          <header>Business Information</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Hours</label>
              <input v-model="state.siteData.contact.hours" placeholder="M-F 10am-2pm" class="w3-input w3-border" />
            </div>
          </div>
        </div>
        <!-- Location -->
        <div class="inputCard">
          <header>Location / Map</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Latitude</label>
              <input v-model="state.siteData.contact.lat" placeholder="44.000000" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Longitude</label>
              <input v-model="state.siteData.contact.lng" placeholder="-71.000000" class="w3-input w3-border" />
            </div>
          </div>
        </div>
        <!-- Social Media -->
        <div class="inputCard">
          <header>Social Media</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Facebook</label>
              <input v-model="state.siteData.social.facebook" placeholder="https://www.facebook.com/goMobileSeven" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Twitter Link</label>
              <input v-model="state.siteData.social.twitter" placeholder="https://www.twitter.com/goMobileSeven" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Twitter Username</label>
              <input v-model="state.siteData.social.twitterun" placeholder="@goMobileSeven" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Instagram</label>
              <input v-model="state.siteData.social.instagram" placeholder="https://www.instagram.com/goMobileSeven" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>LinkedIn</label>
              <input v-model="state.siteData.social.linkedin" placeholder="https://www.linkedin.com/goMobileSeven" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Google Plus</label>
              <input v-model="state.siteData.social.googleplus" placeholder="https://www.instagram.com/goMobileSeven" class="w3-input w3-border" />
            </div>
          </div>
        </div>
      </div>
    </div>

      <div class="w3-right-align w3-margin-top w3-margin-bottom">
        <button class='w3-button' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsSettingsUser',
  data() {
    return {
      state: dataStore.state,
      saving: false,
      saved: false
    }
  },
  methods: {
    saveContent() {
      for (let page in this.sitePages) {
        let index = 0
        let found = false
        for (let setPage of this.state.siteData.site_pages) {
          if (page === setPage) {
            found = true
            break
          }
          index++
        }
        if (this.sitePages[page]) {
          if (!found) {
            this.state.siteData.site_pages.push(page)
          }
        } else {
          if (found) {
            this.state.siteData.site_pages.splice(index, 1)
          }
        }
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    uploadLogo(files) {
      dataStore.uploadImage(files).then((path) => {
        this.state.siteData.site_logo.url = path
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsSettingsUser.vue